export default __webpack_public_path__ + "static/headstand-fullheadstand-1-5d103125ffc9a36a0ca6ae847cccf603.jpg";